import type { PerformanceStatsViewProps } from "@/domains/diagnostics/types"
import { Card } from "@/components/card"

export const PerformanceStatsView = ({ data }: PerformanceStatsViewProps) => {
  return (
    <Card.Container>
      <h3 className="mb-4 text-lg font-semibold text-t100">Performance Statistics</h3>
      <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
        <div>
          <div className="text-sm text-t200">Total Executions</div>
          <div className="text-lg font-semibold text-t100">{data.totalExecutions}</div>
        </div>
        <div>
          <div className="text-sm text-t200">Total Execution Time</div>
          <div className="text-lg font-semibold text-t100">{data.totalExecutionTime.toFixed(2)}ms</div>
        </div>
        <div>
          <div className="text-sm text-t200">Average Execution Time</div>
          <div className="text-lg font-semibold text-t100">{data.averageExecutionTime.toFixed(2)}ms</div>
        </div>
        <div>
          <div className="text-sm text-t200">Queries with Errors</div>
          <div className="text-lg font-semibold text-t100">{data.queriesWithErrors}</div>
        </div>
      </div>
    </Card.Container>
  )
}
